import {
  getCellByUserId,
  getEmailByCPF,
  insertCustomer,
  transformUserToCustomer,
  updateCustomer,
} from "../../../services/RequestService";
import {contactNames} from "../models/formArrayNames";
import {getSessionJwt} from "../../../utils/jwt";

function formatContactWay(contactWay) {
  if (!contactWay) return contactNames.join(",");
  return contactNames.filter((name) => contactWay[name]).join(",");
}

/**
 * Cadastra (sem `props.id`) ou atualiza os dados do cliente.
 * No cadastro, o questionário vai junto no formato novo: { type, answers }.
 * Na atualização, só os dados básicos — questionários têm endpoints próprios.
 */
export default function registerUserRequest(props, state, finishCallback) {
  const {id, from} = props;
  const {basicData, questionnaire, customerId} = state;

  const register = {
    fullname: basicData.fullname,
    cpf: basicData.cpf,
    rg: basicData.rg ?? "",
    birthday: basicData.birthday,
    gender: basicData.gender,
    phone: basicData.cellphone,
    alternativePhone: basicData.alternativePhone,
    responsibleIdentity: basicData.responsibleIdentity,
    email: basicData.email,
    nationality: basicData.nationality,
    occupation: basicData.occupation,
    maritualStatus: basicData.maritalStatus,
    addressStreet: basicData.street,
    addressNumber: basicData.placeNumber,
    addressDistrict: basicData.neighborhood,
    addressCity: basicData.city,
    addressState: basicData.state,
    addressZipCode: basicData.cep,
    addressComplement: basicData?.complement ?? "",
    indication: basicData?.indication ?? "",
    indicatorName: basicData?.indicatorName ?? "",
    indicatorDoc: basicData?.indicatorDoc ?? "",
    contactWay: formatContactWay(basicData.contactWay),
    additionalInformation: basicData.additionalInformation ?? "",
    education: basicData.education,
    receiveNotification: basicData.receiveNotification,
    termOfAgreement: true,
  };

  if (id !== undefined) {
    register.id = customerId;
    register.user_id = id;
    updateCustomer(JSON.stringify(register)).then((res) => {
      if (!res.ok) {
        props.onAddAlert("Houve um erro ao tentar atualizar o cadastro.", "danger", true);
        return finishCallback(null);
      }
      finishCallback("Dados do usuário atualizados.");
    });
    return;
  }

  register.password = basicData.password;
  register.questionnaire = questionnaire;

  const decodedToken = from !== "login" ? getSessionJwt() : undefined;
  register.outsourceAccredittedUser =
    decodedToken?.is_outsourced || decodedToken?.is_accredited ? decodedToken.user_id : null;
  register.userId = from === "login" ? 1 : decodedToken.user_id;
  register.isRetirementWithThreePayment = false;
  register.isRetirementWithFiveHundredPayment = false;
  register.isEncaminhamento = props?.category === "encaminhamento";
  register.isEncaminhamentoDireto = props?.category === "encaminhamento_direto";
  register.isPreAnaliseAposentadoria = props?.category === "pre_analise_aposentadoria";
  register.isPreAnalisePensaoPorMorte = props?.category === "pre_analise_pensao_morte";

  function onRegistered(res) {
    if (res.status !== 200) {
      props.onAddAlert("Houve um erro ao tentar efetuar o cadastro.", "danger", true);
      return finishCallback(null);
    }
    finishCallback("Dados do usuário cadastrados.");
  }

  function registerCall(registerObj) {
    getEmailByCPF({cpf: registerObj.cpf}).then((res) => {
      if (res.data?.email) {
        // usuário já existe (interno/credenciado) — vira cliente
        delete registerObj.email;
        delete registerObj.fullname;
        delete registerObj.password;
        transformUserToCustomer(JSON.stringify(registerObj)).then(onRegistered);
      } else {
        insertCustomer(JSON.stringify(registerObj)).then(onRegistered);
      }
    });
  }

  if (from === "login") {
    register.entryFrom = 1;
    registerCall(register);
  } else {
    getCellByUserId().then((res) => {
      if (res.ok) {
        register.entryFrom = res.data.isIntern ? 2 : 4;
        registerCall(register);
      }
    });
  }
}
